// Lig/turnuva tarihleri eski kayıtlarda saniye, bazılarında Firestore Timestamp (istemci SDK'sı
// ya da serileştirilmiş `_seconds`) veya ISO metni olarak gelir. Hepsini Unix saniyesine çevirir;
// eksik ya da okunamayan değer `null` olur ki "bitti"/NaN gibi yanlış sonuç üretmesin (LG-20).
export const toEpochSeconds = (value: unknown): number | null => {
  if (value === null || value === undefined || value === '') return null;
  if (typeof value === 'number') {
    if (!Number.isFinite(value) || value <= 0) return null;
    // 1e11 saniye ~ 5138 yılı; daha büyük sayı milisaniyedir.
    return value > 1e11 ? Math.floor(value / 1000) : value;
  }
  if (typeof value === 'string') {
    const parsed = Date.parse(value);
    return Number.isNaN(parsed) ? null : Math.floor(parsed / 1000);
  }
  if (value instanceof Date) {
    const time = value.getTime();
    return Number.isNaN(time) ? null : Math.floor(time / 1000);
  }
  if (typeof value === 'object') {
    const record = value as { seconds?: unknown; _seconds?: unknown };
    // eslint-disable-next-line no-underscore-dangle -- firebase-admin Timestamp JSON biçimi.
    const seconds = typeof record.seconds === 'number' ? record.seconds : record._seconds;
    return typeof seconds === 'number' && Number.isFinite(seconds) && seconds > 0 ? seconds : null;
  }
  return null;
};

/** Bitiş tarihi bilinmiyorsa `undefined`: liste "devam ediyor/bitti" rozetini hiç göstermez. */
export const isOngoing = (endDate: unknown, now = Date.now()): boolean | undefined => {
  const end = toEpochSeconds(endDate);
  return end === null ? undefined : end * 1000 > now;
};
